import { render, staticRenderFns } from "./Agree.vue?vue&type=template&id=ad22da94&"
import script from "./Agree.vue?vue&type=script&lang=js&"
export * from "./Agree.vue?vue&type=script&lang=js&"
import style0 from "./Agree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports